module.exports = "https://static.im-cdn.com/mjc/storefront/Accent/static/media/plus.d6769472.svg";